module.exports = __webpack_public_path__ + "img/empty.0926c086.svg";